<template>
  <!--  -->
  <div class="pt-4 px-3 p-3">
    <!--  -->
    <div id="filterBar" class="flex flex-col border p-4 rounded-lg bg-white">
      <!--  -->
      <div class="flex flex-row">
        <!--  -->
        <div class="flex w-full">
          <!--  -->
          <input :placeholder="filters.elements.search.options.hint" v-model="searchText" type="search" @change="searchChild" class="border-t text-gray-700 text-xs border-b border-l rounded-l-md w-full focus:outline-none py-1 px-4" />
          <!--  -->
          <button class="bg-white rounded-r-md text-primary-500 border-t border-r border-b hover:opacity-75 px-3 focus:outline-none">
            <!--  -->
            <i class="py-1 material-icons">search</i>
            <!--  -->
          </button>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="">
          <!--  -->
          <button @click="showMore = !showMore" class="text-white hover:bg-gray-400 rounded-full bg-primary-600 flex items-center focus:outline-none p-2 ml-2">
            <!--  -->
            <i v-if="showMore" class="material-icons">keyboard_arrow_up</i>
            <!--  -->
            <i v-else class="material-icons">keyboard_arrow_down</i>
            <!--  -->
          </button>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="flex flex-col gap-4" v-if="showMore">
        <!--  -->
        <div class="flex flex-row space-x-3 justify-center flex-wrap mt-6">
          <!--  -->
          <div v-for="(item, index) in filters.elements.champs" :key="index" class="w-56" v-show="isShown(item)">
            <!--  -->
            <div class="border h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="seller" class="bg-white text-gray-700 px-1">{{ item.label }}
                    <!--  -->
                    <span :class="$colors.required">*</span>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div v-if="item.type == 'select'">
                <!--  -->
                <div v-if="item.name">
                  <!--  -->
                  <v-select @search="searchMore($event, item.key)" :label="item.name" v-model="filter[item.key]" :options="item.values"></v-select>
                  <!--  -->
                </div>
                <!--  -->
                <div v-else>
                  <!--  -->
                  <v-select v-model="filter[item.key]" :options="item.values"></v-select>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div v-if="item.type == 'number'">
                <!--  -->
                <input :max="item.max" :min="item.min" :placeholder="item.name" :step="item.step" v-model="filter[item.key]" type="number" :name="item.key" :id="item.key" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div v-if="item.type == 'date'">
                <!--  -->
                <input v-if="item.type != 'date'" v-model="filter[item.key]" :placeholder="item.placeholder" :type="item.type" :name="item.key" :id="item.key" :class="item.class">
                <!--  -->
                <date-picker v-else :placeholder="item.placeholder" @change="DateRange" format="yyyy-MM-DD" class="w-full-imp" v-model="filter[item.key]" range></date-picker>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="flex flex-row justify-center space-x-2">
          <!--  -->
          <button @click="ClearFilters" class="text-primary-500 rounded-md mx-1 border border-gray-100 bg-gray-300 hover:bg-primary-600 w-1/6 hover:text-white py-2 px-4 focus:outline-none">
            <!--  -->
            Reset
            <!--  -->
          </button>
          <!--  -->
          <button @click="filtrer" class="rounded-md mx-1 border border-gray-100 bg-primary-600 hover:bg-primary-600 text-white py-2 px-4 w-1/6 focus:outline-none">
            <!--  -->
            Filtrer
            <!--  -->
          </button>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  props: {
    filters: { required: true, type: Object },
    name: { type: String, default: '' },
    pFiltrer: { type: Function },
    pSearch: { type: Function },
  },
  data() {
    return {
      showMore: false,
      searchText: '',
      filter: {},
    };
  },
  methods: {
    DateRange(){},
    isShown(item) {
      let shown = !item.show || (item.show && this.filter[item.show.key] == item.show.equal);
      if (!shown) this.$set(this.filter, item.key, null);
      return shown;
    },
    async searchChild() {
      this.$emit('search', this.searchText);
    },
    async filtrer() {
      this.$emit('filtrer', this.filter);
    },
    async ClearFilters(val) {
      console.log('is reset bar')
      this.$emit('reset', val);
    },
    searchMore: function (value, event) {
      if (event == 'role') this.$emit('searchRoles', value, event);
    },
  },
};
</script>

<style></style>
